import React from 'react'
import InvoiceFormInfo from "./InvoiceFormInfo";
import InvoiceItem from "./InvoiceItem";
export default function Invoice() {
  return (<>
  <InvoiceFormInfo/>
  <InvoiceItem/>
  </>)
}
